export default "__VITE_PUBLIC_ASSET__1ec0bdb3__"